/* eslint-disable react/prop-types */
import { Icon, Tooltip } from "@mui/material";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import { getUproColor } from "utils/colors";
import { makeNiceText } from "utils/formatters";

const getRows = (data, accion) => {
  const rows = [];
  if (data) {
    data.forEach((item) => {
      rows.push({
        id: (
          <SoftBox ml={2}>
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="dark"
              fontWeight="bold"
            >
              {item?.id}
            </SoftTypography>
          </SoftBox>
        ),
        icono: (
          <SoftBox>
            <Icon
              sx={{
                verticalAlign: "middle",
                color: getUproColor("uproGreen"),
              }}
              fontSize="small"
            >
              {item?.icono}
            </Icon>
          </SoftBox>
        ),
        categoria: (
          <SoftBox sx={{
            minWidth: "200px",
          }}>
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="dark"
              fontWeight="bold"
            >
              {makeNiceText(item?.categoria)}
            </SoftTypography>
          </SoftBox>
        ),
        accion: (
          <SoftBox mr={2}  gap={1} sx={{
            display: item?.categoriaPermanente ? "none" : "flex",
          }}>
            <Tooltip title="Editar" placement="top">
              <Icon
                // color="dark"
                fontSize="small"
                sx={{
                  cursor: "pointer",
                  color: getUproColor("uproGreen"),
                }}
                onClick={() => {
                  accion("editar", item);
                }}
              >
                edit
              </Icon>
            </Tooltip>
            <Tooltip title="Eliminar" placement="top">
              <Icon
                fontSize="small"
                sx={{
                  cursor: "pointer",
                  color: getUproColor("uproPink"),
                }}
                onClick={() => {
                  accion("borrar", item);
                }}
              >
                delete
              </Icon>
            </Tooltip>
          </SoftBox>
        ),
      });
    });
  }

  return rows;
};

const columns = [
  { name: "id", desc: "ID", align: "left", width: "1%" },
  { name: "icono", desc: "Ícono", align: "left", width: "1%", noOrder: true },
  { name: "categoria", desc: "Nombre", align: "left" },
  { name: "accion", desc: " ", align: "center", width: "1%", noOrder: true },
];

export default { columns, getRows };
